<template>
    <modal
        ref="modal"
        :title="title"
        @close="$emit('close')"
    >
        <event-form
            :event="event"
            @saved="onSaved"
            @cancel="close"
        />
    </modal>
</template>

<script>
import Modal from "../../modals/ModalComponent.vue";
import EventForm from "./Form.vue";

export default {
    components: {
        Modal,
        EventForm,
    },
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    emits: ["saved", "close"],
    computed: {
        title() {
            const prefix = this.event.id ? "Edit" : "New";
            const type = this.event.type || "Event";

            return `${prefix} ${type}`;
        },
    },
    watch: {
        event: {
            handler() {
                this.checkModal();
            },
        },
    },
    mounted() {
        this.checkModal();
    },
    methods: {
        onSaved(event) {
            this.$emit("saved", event);
        },
        close() {
            this.$refs.modal.close();
            this.$emit("close");
        },
        checkModal() {
            if (this.event) {
                this.$refs.modal.open();
                return;
            }
            this.$refs.modal.close();
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/calendar/FormModal.vue